var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-component":"answer-icon","data-icon":_vm.icon}},[(_vm.icon)?_c('icon',{attrs:{"data-element":"answer-icon","icon":_vm.icon,"colour":_vm.getIconColour}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }